(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-help-popup"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const roots = document.querySelectorAll('[data-floating-help]');

      const getGorgiasChatInit = () => {
        if (window.GorgiasChat && typeof window.GorgiasChat.init === 'function') {
          return window.GorgiasChat.init();
        }

        if (window.__floatingHelpGorgiasInitPromise) {
          return window.__floatingHelpGorgiasInitPromise;
        }

        window.__floatingHelpGorgiasInitPromise = new Promise((resolve) => {
          window.addEventListener('gorgias-widget-loaded', () => resolve(), { once: true });
        });

        return window.__floatingHelpGorgiasInitPromise;
      };

      const getGorgiasLauncher = () => {
        return document.querySelector('#gorgias-chat-container #chat-button') || document.querySelector('#chat-button');
      };

      const setGorgiasLauncherVisible = (isVisible) => {
        const launcher = getGorgiasLauncher();

        if (!launcher) {
          return false;
        }

        launcher.style.display = isVisible ? '' : 'none';
        return true;
      };

      const waitForGorgiasLauncher = (isVisible) => {
        let attempts = 0;

        const timer = window.setInterval(() => {
          attempts += 1;

          if (setGorgiasLauncherVisible(isVisible) || attempts >= 80) {
            window.clearInterval(timer);
          }
        }, 50);
      };

      const observeGorgiasLauncher = (root) => {
        if (root.dataset.gorgiasLauncherObserver === 'true' || typeof window.MutationObserver !== 'function') {
          return;
        }

        root.dataset.gorgiasLauncherObserver = 'true';

        const observer = new MutationObserver(() => {
          setGorgiasLauncherVisible(root.classList.contains('floating-help--gorgias-open'));
        });

        observer.observe(document.body, { childList: true, subtree: true });
      };
  
      for (const root of roots) {
        if (root.dataset.initialized === 'true') {
          continue;
        }
  
        root.dataset.initialized = 'true';
  
        const panel = root.querySelector('.floating-help__panel');
        const toggle = root.querySelector('.floating-help__toggle');
        const closeButton = root.querySelector('.floating-help__close');
        const gorgiasChatTriggers = root.querySelectorAll('[data-gorgias-chat-trigger]');
  
        if (!panel || !toggle || !closeButton) {
          continue;
        }
  
        const setOpen = (isOpen) => {
          panel.classList.toggle('is-open', isOpen);
          panel.setAttribute('aria-hidden', String(!isOpen));
          toggle.setAttribute('aria-expanded', String(isOpen));
          toggle.setAttribute('aria-label', isOpen ? 'Cerrar panel de ayuda' : 'Abrir panel de ayuda');
        };

        const setGorgiasChatOpen = (isOpen) => {
          root.classList.toggle('floating-help--gorgias-open', isOpen);
          waitForGorgiasLauncher(isOpen);

          if (isOpen) {
            setOpen(false);
          }
        };

        const syncGorgiasChatState = () => {
          if (window.GorgiasChat && typeof window.GorgiasChat.isOpen === 'function') {
            setGorgiasChatOpen(window.GorgiasChat.isOpen());
            return;
          }

          setGorgiasChatOpen(false);
        };
  
        toggle.addEventListener('click', () => {
          setOpen(!panel.classList.contains('is-open'));
        });
  
        closeButton.addEventListener('click', () => {
          setOpen(false);
        });

        for (const trigger of gorgiasChatTriggers) {
          trigger.addEventListener('click', async () => {
            setOpen(false);

            try {
              await getGorgiasChatInit();
              if (window.GorgiasChat && typeof window.GorgiasChat.open === 'function') {
                window.GorgiasChat.open();
                setGorgiasChatOpen(true);
              }
            } catch (error) {
              /* Gorgias is unavailable on this page. */
            }
          });
        }

        getGorgiasChatInit()
          .then(() => {
            syncGorgiasChatState();

            if (window.GorgiasChat && typeof window.GorgiasChat.on === 'function') {
              window.GorgiasChat.on('widget:opened', () => setGorgiasChatOpen(true));
              window.GorgiasChat.on('widget:closed', () => setGorgiasChatOpen(false));
            }
          })
          .catch(() => {
            /* Gorgias is unavailable on this page. */
          });

        observeGorgiasLauncher(root);
  
        document.addEventListener('click', (event) => {
          if (!root.contains(event.target)) {
            setOpen(false);
          }
        });
  
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            setOpen(false);
          }
        });
      }
  
      if (!document.querySelector('[data-floating-help][data-has-lucide="true"]')) {
        return;
      }
  
      const loadLucide = () => {
        if (window.lucide && typeof window.lucide.createIcons === 'function') {
          return Promise.resolve(window.lucide);
        }
  
        if (window.__floatingHelpLucidePromise) {
          return window.__floatingHelpLucidePromise;
        }
  
        window.__floatingHelpLucidePromise = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://unpkg.com/lucide@latest';
          script.async = true;
          script.onload = () => resolve(window.lucide);
          script.onerror = reject;
          document.head.appendChild(script);
        });
  
        return window.__floatingHelpLucidePromise;
      };
  
      loadLucide()
        .then((lucide) => {
          if (lucide && typeof lucide.createIcons === 'function') {
            lucide.createIcons({ attrs: { width: 24, height: 24 } });
          }
        })
        .catch(() => {
          /* no-op */
        });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

      // Dynamically set --switch-bar-height from the actual announcement bar height
      const announcementBar = document.querySelector('.announcement-bar-section');
      if (announcementBar) {
        const abHeight = announcementBar.offsetHeight;
        document.documentElement.style.setProperty('--switch-bar-height', `${abHeight}px`);

        // Watch for height changes (e.g. font size adjustments)
        if (!this._abResizeObserver) {
          this._abResizeObserver = new ResizeObserver(() => {
            const h = announcementBar.offsetHeight;
            document.documentElement.style.setProperty('--switch-bar-height', `${h}px`);
          });
          this._abResizeObserver.observe(announcementBar);
        }
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      // Keep inline search always open
      const inlineSearch = this.header.querySelector('.header__search-wrapper .header__search details');
      if (inlineSearch) return;

      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
